import { Box, Typography } from "@mui/material";
import icon from "src/assets/images/device-type-icons/temperature-sensor.svg";

import DeviceWidgetTitle from "../../device-title";

interface Props {
  device: Device;
}
export default function TemperatureSensorDevice(props: Props) {
  const { device } = props;
  const { temperature } = device;
  const { config } = device;
  const { scale } = config;

  const formattedTemperature = temperature?.toFixed(2) ?? "--.--";

  return (
    <Box
      sx={{
        backgroundColor: "white",
        height: "100%",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DeviceWidgetTitle device={device} />
      <Box sx={{ display: "flex", justifyContent: "space-between", flex: 2 }}>
        <Box
          sx={{
            paddingLeft: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <img src={icon} width={"60"} />
        </Box>
        <Box sx={{ flex: 1 }} />
        <Typography
          variant="h2"
          sx={{ color: "grey", marginRight: "15px", marginTop: "10px" }}
        >
          {formattedTemperature} °{scale}
        </Typography>
      </Box>
    </Box>
  );
}
